import script from "./MessageItemDirectChat.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessageItemDirectChat.vue?vue&type=script&lang=ts&setup=true"

import "./MessageItemDirectChat.vue?vue&type=style&index=0&id=5d71d84e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d71d84e"]])

export default __exports__